import { FeesConfigurationType } from './types';

export const FREQUENCY_VALUES = {
  HALF_MONTH: 0.5,
  ONE_MONTH: 1,
  TWO_MONTHS: 2,
  THREE_MONTHS: 3,
};

export const FREQUENCY_OPTIONS = [
  {
    value: FREQUENCY_VALUES.HALF_MONTH,
    label: `Equal to half month's rent`,
  },
  {
    value: FREQUENCY_VALUES.ONE_MONTH,
    label: `Equal to one month's rent`,
  },
  {
    value: FREQUENCY_VALUES.TWO_MONTHS,
    label: `Equal to two month's rent`,
  },
  {
    value: FREQUENCY_VALUES.THREE_MONTHS,
    label: `Equal to three month's rent`,
  },
];

export const RENTAL_FEES_CONFIGURATIONS: FeesConfigurationType[] = [
  { title: 'Pet Fee', key: 'pet_fee' },
  { title: 'Parking Fee', key: 'parking_fee' },
  { title: 'Respite Fee', key: 'respite_fee' },
  { title: 'Additional Fee', key: 'additional_fee' },
  { title: 'Move-in Fee', key: 'move_in_fee' },
  { title: 'Entrance Fee', key: 'entrance_fee' },
  { title: '2nd Person Monthly Fee', key: 'second_person_fee' },
  { title: 'Emergency Pendant Fee', key: 'emergency_pendant_fee' },
];

export const CCRC_FEES_CONFIGURATIONS: FeesConfigurationType[] = [
  { title: '2nd Person Entrance Fee', key: 'second_person_entrance_fee' },
];

export const ITEM_VIEW_HISTORY_CLASS = 'item-view-history';
